<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">卡券管理</span>
            </el-breadcrumb-item>
        </el-breadcrumb>

        <el-form :inline="true" style="margin-top: 20px;">
            <el-form-item label="卡券种类">
                <el-select v-model="queryCondition.type" @change="queryCondition.page = 1,queryCouponList()">
                    <el-option v-for="item in couponTypes" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态">
                <el-select  v-model="queryCondition.status" clearable>
                    <el-option v-for="item in status" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="币种">
                <coin-select :coinType = "queryCondition.coinType" @value="val => queryCondition.coinType = val"></coin-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryCondition.page = 1,queryCouponList()">搜索</el-button>
                <el-button type="primary" @click="opType = 'insert',showEdit = true">新建</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="couponInfo" v-show="queryCondition.type === 0">
            <el-table-column label="创建时间" width="150">
                <template slot-scope="scope">{{parseDateTime(scope.row.createTime)}}</template>
            </el-table-column>
            <el-table-column label="收购种类">
                <template slot-scope="scope">{{parseCodeToDesc(scope.row.acquireType,acquireTypes)}}</template>
            </el-table-column>
            <el-table-column label="卡券种类"  width="150">
               <template slot-scope="scope">{{parseCodeToDesc(scope.row.type,couponTypes)}}</template>
            </el-table-column>
            <el-table-column label="适用"  width="150">
                <template slot-scope="scope">
                   <span><={{scope.row.limit + scope.row.coinType}}</span>
                </template>
            </el-table-column>
            <el-table-column label="加息利率">
                <template slot-scope="scope">{{scope.row.rate}}%</template>
            </el-table-column>
            <el-table-column label="加息天数">
                <template slot-scope="scope">{{scope.row.days}}天</template>
            </el-table-column>
            <el-table-column label="有效期">
                <template slot-scope="scope">{{scope.row.validityDay}}天</template>
            </el-table-column>
            <el-table-column label="售卖价格"  width="120">
                <template slot-scope="scope">{{scope.row.price + scope.row.payCoin}}</template>
            </el-table-column>
            <el-table-column label="售卖开始时间" width="160">
                <template slot-scope="scope">{{parseDateTime(scope.row.startTime)}}</template>
            </el-table-column>
            <el-table-column label="售卖结束时间/兑换有效期止" width="160">
                <template slot-scope="scope">{{parseDateTime(scope.row.endTime)}}</template>
            </el-table-column>
            <el-table-column label="状态"  width="150">
                <template slot-scope="scope">{{parseCodeToDesc(scope.row.status,status)}}</template>
            </el-table-column>
            <el-table-column label="总量" prop="totalCount"></el-table-column>
            <el-table-column label="已售/已兑" prop="usedCount"></el-table-column>
            <el-table-column label="已使用" prop="hasBeenUsed"></el-table-column>
            <el-table-column label="使用中" prop="usingCount"></el-table-column>
            <el-table-column label="开关" fixed="right">
                <template slot-scope="scope">
                    <el-switch :value="scope.row.showed" @change="handleSwitchChange(scope.row, $event)" active-color="#13ce66" v-if="scope.row.acquireType !== 1"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="230">
                <template slot-scope="scope">
                    <el-button type="text" v-if="scope.row.status === 0" @click="opType = 'update',buildCouponEditInfo(scope.row)">修改</el-button>
                    <el-button type="text" @click="opType = 'query',buildCouponEditInfo(scope.row)">查看</el-button>
                    <el-button type="text" v-if="scope.row.status === 0" @click="startCouponHandle(scope.row.id)">开售/开兑</el-button>
                    <el-button type="text" v-if="scope.row.status === 1" @click="stopCouponHandle(scope.row.id)">停售/停兑</el-button>
                    <el-button type="text" v-if="scope.row.acquireType === 1" @click="getCouponRedeemCode(scope.row.id)">下载兑换码</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-table :data="couponInfo" v-show="queryCondition.type === 1 || queryCondition.type === 2">
            <el-table-column label="创建时间" width="150">
                <template slot-scope="scope">{{parseDateTime(scope.row.createTime)}}</template>
            </el-table-column>
            <el-table-column label="收购种类">
                <template slot-scope="scope">{{parseCodeToDesc(scope.row.acquireType,acquireConTypes)}}</template>
            </el-table-column>
            <el-table-column label="卡券种类"  width="150">
                <template slot-scope="scope">{{parseCodeToDesc(scope.row.type,couponTypes)}}</template>
            </el-table-column>
            <el-table-column label="币种" prop="coinType"></el-table-column>
            <el-table-column label="面值" prop="faceValue"></el-table-column>
            <el-table-column label="券码数量" prop="totalCount"></el-table-column>
            <el-table-column label="有效期">
                <template slot-scope="scope">{{scope.row.validityDay}}天</template>
            </el-table-column>
            <el-table-column label="激活率">
                <template slot-scope="scope">{{(scope.row.usedCount/scope.row.totalCount) * 100}}%</template>
            </el-table-column>
            <el-table-column label="备注" prop="remark"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="clickShowRedeemCodeInfo(scope.row.id)">查看</el-button>
                  <!--  <el-button type="text" @click="opType = 'update',buildContractEditInfo(scope.row)">修改</el-button>-->
                    <el-button type="text" @click="stopCouponHandle(scope.row.id)">停兑</el-button>
                    <el-button type="text" @click="exportContractRedeemCode(scope.row.id)">下载</el-button>
                    <el-button type="text" @click="clickCouponRedeemCodeRemove(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>

        </el-table>

        <el-pagination background layout="prev, pager, next" :total="couponTotal" :page-size="15" :current-page="queryCondition.page"
                       @current-change="queryCouponList"></el-pagination>

        <el-dialog title="卡券配置" :visible.sync= "showEdit" @close="closeDialog">
            <el-form label-width="150px" :model="couponEditInfo" ref="couponEditForm">
                <el-form-item label="卡券种类" prop="couponType" :rules="[{ required: true, message: '卡券种类不能为空',trigger: 'blur'}]">
                    <el-select v-model="couponEditInfo.couponType" @change="couponEditInfo.acquireType = ''">
                        <el-option v-for="item in couponTypes" :key="item.code" :label="item.desc" :value="item.code"/>
                    </el-select>
                </el-form-item>
                 <span v-if="this.couponEditInfo.couponType === 0">
                 <el-form-item label="收购种类" prop="acquireType" :rules="[{ required: true, message: '收购种类不能为空',trigger: 'blur'}]">
                    <el-select v-model="couponEditInfo.acquireType">
                        <el-option v-for="item in acquireTypes" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="适用" prop="limit" :rules="[{ required: true, message: '适用范围不能为空',trigger: 'blur'}]">
                    <el-col :span="6">
                        <el-input placeholder="请填入数字，且为整数" v-model="couponEditInfo.limit"></el-input>
                    </el-col>
                    <el-col :span="4">
                        <coin-select :coinType = "couponEditInfo.coinType" @value="val => couponEditInfo.coinType = val"></coin-select>
                    </el-col>
                </el-form-item>
                <el-form-item label="加息利率" prop="rate" :rules="[{ required: true, message: '加息利率不能为空',trigger: 'blur'}]">
                    <el-input style="width: 20%" v-model="couponEditInfo.rate"></el-input>  &nbsp;&nbsp; %
                </el-form-item>
                <el-form-item label="加息天数" prop="days" :rules="[{ required: true, message: '加息天数不能为空',trigger: 'blur'}]">
                    <el-radio-group v-model="couponEditInfo.days">
                        <el-radio :label="3">3天</el-radio>
                        <el-radio :label="7">7天</el-radio>
                        <el-radio :label="15">15天</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="有效期" prop="validityDay" :rules="[{ required: true, message: '有效期不能为空',trigger: 'blur'}]">
                    <el-radio-group v-model="couponEditInfo.validityDay">
                        <el-radio :label="15" v-if="couponEditInfo.acquireType === 1">15天</el-radio>
                        <el-radio :label="30">30天</el-radio>
                        <el-radio :label="45" v-if="couponEditInfo.acquireType === 1">45天</el-radio>
                        <el-radio :label="60" v-if="couponEditInfo.acquireType === 1">60天</el-radio>
                        <el-radio :label="90">90天</el-radio>
                        <el-radio :label="120" v-if="couponEditInfo.acquireType === 1">120天</el-radio>
                        <el-radio :label="180" v-if="couponEditInfo.acquireType === 0">180天</el-radio>
                        <el-radio :label="360" v-if="couponEditInfo.acquireType === 0">360天</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="售卖价格" prop="price" :rules="[{ required: true, message: '售卖价格不能为空',trigger: 'blur'}]" v-if="couponEditInfo.acquireType === 0">
                    <el-input style="width: 25%" v-model="couponEditInfo.price"></el-input>&nbsp;&nbsp; BKK
                </el-form-item>
                <el-form-item label="创建总量" prop="totalCount" :rules="[{ required: true, message: '创建总量不能为空',trigger: 'blur'}]">
                    <el-input style="width: 25%" placeholder="请输入数字，且为整数" v-model="couponEditInfo.totalCount"></el-input>
                </el-form-item>
                <el-form-item v-if="couponEditInfo.acquireType === 0" label="最少可买数量/UID" prop="minCount" :rules="[{ required: true, message: '最少可买数量不能为空',trigger: 'blur'}]">
                    <el-input style="width: 25%;" placeholder="请输入数字，且为整数" v-model="couponEditInfo.minCount"></el-input>
                </el-form-item>
                <el-form-item v-if="couponEditInfo.acquireType === 0" label="最多可买数量/UID" prop="maxCount" :rules="[{ required: true, message: '最多可买数量不能为空',trigger: 'blur'}]">
                    <el-input style="width: 25%;" placeholder="请输入数字，且为整数" v-model="couponEditInfo.maxCount"></el-input>
                </el-form-item>
                 <el-form-item :label=" couponEditInfo.acquireType === 0 ? '售卖时间' : '兑换有效期'">
                    <el-date-picker v-model="datePicker" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"></el-date-picker>
                </el-form-item>
                 </span>

                <span v-if="this.couponEditInfo.couponType === 1 || this.couponEditInfo.couponType === 2">
                    <el-form-item label="收购种类" prop="acquireType" :rules="[{ required: true, message: '收购种类不能为空',trigger: 'blur'}]">
                    <el-select v-model="couponEditInfo.acquireType">
                        <el-option v-for="item in acquireConTypes" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item label="生成数量" prop="totalCount" :rules="[{ required: true, message: '生成数量不能为空',trigger: 'blur'}]">
                        <el-input v-model="couponEditInfo.totalCount" :disabled="opType === 'update'"></el-input>
                    </el-form-item>
                    <el-form-item label="体验金币种">
                        <el-autocomplete class="inline-input" v-model="couponEditInfo.coinType" :fetch-suggestions="querySearch" placeholder="请输入体验金币种"/>
                    </el-form-item>
                    <el-form-item label="每份体验金数量" prop="faceValue" :rules="[{ required: true, message: '每份体验金数量不能为空',trigger: 'blur'}]">
                        <el-input v-model="couponEditInfo.faceValue"></el-input>
                    </el-form-item>
                    <el-form-item label="有效期" prop="validityDay" :rules="[{ required: true, message: '有效期不能为空',trigger: 'blur'}]">
                        <el-input v-model="couponEditInfo.validityDay" :disabled="opType === 'update'"></el-input><span>天</span>
                    </el-form-item>
                    <el-form-item label="备注渠道">
                        <el-input v-model="couponEditInfo.remark"></el-input>
                    </el-form-item>
                    <span>用于生成EXCEL用户名以及识别渠道，一般不超过20字符</span>
                </span>

                <el-form-item label="是否实名" prop="iskyc" :rules="[{ required: true, message: '是否实名不能为空',trigger: 'blur'}]">
                    <el-radio-group v-model="couponEditInfo.iskyc">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item v-if="opType !== 'query'">
                    <el-button type="info" @click="closeDialog()">取消</el-button>
                    <el-button type="primary" @click="saveCouponEdit()">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-table :data="redeemCode" id="downloadRedeemCode" v-show="false">
            <el-table-column prop="code" label="兑换码"></el-table-column>
        </el-table>

        <el-dialog title="兑换码查询" :visible.sync="showRedeemCode">
            <el-form :inline="true" label-width="100px">
                <el-form-item label="创建时间：">{{parseDateTime(showRedeemCodeInfo.createTime)}}</el-form-item>
                <el-form-item label="币种："> {{showRedeemCodeInfo.coinType}}</el-form-item>
                <el-form-item label="面值：">{{showRedeemCodeInfo.faceValue}}</el-form-item>
                <el-form-item label="有效期：">{{showRedeemCodeInfo.validityDay}} 天</el-form-item>
            </el-form>
            <el-form :inline="true" label-width="100px">
                <el-form-item label="兑换码数量：">{{countNum(showRedeemCodeInfo.redeemList)}}</el-form-item>
                <el-form-item label="激活率：">{{(showRedeemCodeInfo.usedCount/showRedeemCodeInfo.totalCount) * 100}}%</el-form-item>
                <el-form-item label="备注：">{{showRedeemCodeInfo.remark}}</el-form-item>
            </el-form>
            <el-form :inline="true">
                <el-form-item v-for="item in showRedeemCodeInfo.redeemList">
                    <div style="border-style:solid;border-width: 1px;border-color: rgba(179,182,241,0.49);">
                        &nbsp;&nbsp;&nbsp;&nbsp;<span>{{item.redeemCode}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                        <el-checkbox v-model="item.status !== 0" :disabled="item.status === 1" @change="item.status = 3,changeRedeemCode(item.redeemCode,showRedeemCodeInfo.id)">{{item.status === 1 ? '已使用' : '停兑'}}&nbsp;&nbsp;</el-checkbox>
                        <span v-if="item.status === 1"> <br>&nbsp;&nbsp;&nbsp;&nbsp;userId:{{item.userId}}</span>
                    </div>
                </el-form-item>
            </el-form>

        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import api from './api';
    import {mapActions, mapState} from 'vuex';
    import coinSelect from '../../components/coinSelect';
    import fileSaver from 'file-saver';
    import xlsx from 'xlsx';
    export default {
        name: "coupon",
        components:{coinSelect},
        data(){
            return {
                queryCondition:{coinType:'',type:0,status:'',page:1,size:15},
                couponTypes :[{code: 0,desc: '活期宝·加息券'},{code:1,desc: '合约体验金兑换码'},{code:2,desc: '超级合约体验金兑换码'}],
                status: [{code:'0',desc:'未开始'},{code:'1',desc:'销售中/兑换中'},{code:'2',desc:'售罄/兑换完成'},{code:'3',desc:'停售/停兑'}],
                opType: '',// update/insert/query
                showEdit: false,
                couponEditInfo:{payCoin:'BKK',coinType:'',iskyc:false,acquireType:1},
                acquireTypes:[{code:0,desc:'购买'},{code:1,desc:'兑换'}],//,{code:2,desc:'转让'},{code:3,desc:'赠送'}
                acquireConTypes:[{code:1,desc:'赠送'}],
                datePicker:[],
                redeemCode:[],
                showRedeemCode:false,
                showRedeemCodeInfo:{},
                contractCoinTypes:['BTC','USDT','BCH','EOS','ETH','LTC','XRP','BKK','CSPC'],
            }
        },
        computed : {...mapState('coupon',['couponTotal','couponInfo'])},
        created(){
            this.findCouponInfo(this.queryCondition);
        },
        methods:{
            ...mapActions('coupon',['findCouponInfo']),
            closeDialog(){
                this.couponEditInfo = {payCoin:'BKK',coinType:'',iskyc:false,acquireType:1};
                this.queryCondition.page = 1;
                this.queryCouponList();
                this.showEdit = false;
            },
            queryCouponList(val){
                this.queryCondition.page = val;
                this.findCouponInfo(this.queryCondition);
            },
            parseCodeToDesc(code,infos){
                for (let index in infos){
                    if (infos[index].code == code){
                        return infos[index].desc;
                    }
                }
            },
            parseDateTime(time){
                let now = new Date(time);
                let year=now.getFullYear();
                let month=now.getMonth()+1;
                let date=now.getDate();
                let hour=now.getHours();
                let minute=now.getMinutes();
                let second=now.getSeconds();
                return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second;
            },
            saveCouponEdit(){
                this.$refs['couponEditForm'].validate((valid) => {
                    if (valid) {
                        if (this.couponEditInfo.couponType === 0) {
                            if (isNaN(this.couponEditInfo.limit) || this.couponEditInfo.limit.length > 11){
                                this.$message.error('适用范围必须为数字且长度小于11');return;
                            }
                            if (!this.couponEditInfo.coinType){
                                this.$message.error('适用的币种数据不能为空');return;
                            }
                            if (isNaN(this.couponEditInfo.rate)){
                                this.$message.error('加息利率必须为数字');return;
                            }
                            if (this.couponEditInfo.price && isNaN(this.couponEditInfo.price)){
                                this.$message.error('售卖价格必须为数字');return;
                            }
                            if (isNaN(this.couponEditInfo.totalCount)){
                                this.$message.error('创建总量必须为数字');return;
                            }
                            if (this.couponEditInfo.minCount && isNaN(this.couponEditInfo.minCount)){
                                this.$message.error('最少可买数量/UID必须为数字');return;
                            }
                            if (this.couponEditInfo.maxCount && isNaN(this.couponEditInfo.maxCount)){
                                this.$message.error('最多可买数量/UID必须为数字');return;
                            }
                            this.couponEditInfo.rate = (this.couponEditInfo.rate*100) / 10000;
                            if (this.datePicker.length === 0){this.$message.error("售卖时间或兑换有效期不能为空");return;}
                            this.couponEditInfo.startTime = this.datePicker[0];
                            this.couponEditInfo.endTime = this.datePicker[1];
                        }
                        if (this.couponEditInfo.couponType === 1) {
                            if (!this.couponEditInfo.coinType){
                                this.$message.error('体验金币种不能为空');return;
                            }
                            if (isNaN(this.couponEditInfo.totalCount)) {
                                this.$message.error('生成体验金数量必须为整数');return;
                            }
                            let a = this.couponEditInfo.totalCount;
                            let b = String(a).indexOf(".") + 1;
                            if (b > 0) {
                                this.$message.error('生成体验金数量必须为整数');return;
                            }
                            if (isNaN(this.couponEditInfo.faceValue)){
                                this.$message.error('每份体验金数量必须为数字');return;
                            }
                            let x = this.couponEditInfo.faceValue;//测试的数字
                            let y = String(x).indexOf(".") + 1;//获取小数点的位置
                            let count = String(x).length - y;//获取小数点后的个数
                            if (y > 0 && count > 6) {
                                this.$message.error('每份体验金数量小数位数需要小于6');return;
                            }
                        }

                        if (this.opType === 'insert'){
                            api.addCoupon(this.couponEditInfo).then(() =>{
                                this.$message.success("新增成功");
                                this.closeDialog();
                            })
                        }
                        if (this.opType === 'update'){
                            api.updateCoupon(this.couponEditInfo).then(() =>{
                                this.$message.success('更新成功');
                                this.closeDialog();
                            })
                        }
                    }
                })
            },
            handleSwitchChange(info,status){
                api.showCoupon({id:info.id}).then(() =>{this.queryCouponList();})
            },
            startCouponHandle(id){
                api.startCoupon({id:id}).then(() =>{this.queryCouponList()})
            },
            stopCouponHandle(id){
                api.stopCoupon({id:id}).then(() =>{
                    this.$message.success('操作成功');
                    this.queryCouponList();
                })
            },
            getCouponRedeemCode(id){
                this.redeemCode = [];
                api.getCouponRedeem({id:id}).then(response =>{
                    let data = response.data.redeemList;
                    data.forEach((v, i, a) => {
                        this.redeemCode.push({code:v.redeemCode});
                    });
                    window.setTimeout(() => {
                            this.exportTable('加息券兑换码');
                        }, 1);
                })
            },
            exportContractRedeemCode(id) {
                this.redeemCode = [];
                api.getCouponRedeem({id:id}).then(response =>{
                    let data = response.data.redeemList;
                    let info = response.data;
                    let title = info.remark + '的合约体验金兑换码';
                    let first = "有效期：" + this.parseDateTime(info.startTime) + "-" + this.parseDateTime(info.endTime) + "/币种：" + info.coinType + "/每份数量：" + info.faceValue + " " + info.coinType;
                    this.redeemCode.push({code: first});
                    data.forEach((v, i, a) => {
                        if (v.status === 0 ){
                            this.redeemCode.push({code:v.redeemCode});
                        }
                    });
                    window.setTimeout(() => {
                        this.exportTable(title);
                    }, 1);
                })
            },
            exportTable(title){
                let box = xlsx.utils.table_to_book(document.querySelector('#downloadRedeemCode'),{raw:true});
                let out = xlsx.write(box, {bookType: 'xlsx', bookSST: true, type: 'array'});
                try {
                    fileSaver.saveAs(new Blob([out], {type: 'application/octet-stream'}), title + '.xlsx');
                } catch (e) {
                    console.log(e)
                }
                return out
            },
            buildCouponEditInfo(row){
                this.couponEditInfo = JSON.parse(JSON.stringify(row));
                this.datePicker[0] = row.startTime;
                this.datePicker[1] = row.endTime;
                this.couponEditInfo.couponType = row.type;
                this.showEdit = true;
            },
            buildContractEditInfo(row) {
                this.couponEditInfo = JSON.parse(JSON.stringify(row));
                this.couponEditInfo.couponType = row.type;
                this.showEdit = true;
            },
            clickShowRedeemCodeInfo(id){
                api.getCouponRedeem({id:id}).then(response =>{
                    this.showRedeemCodeInfo = response.data;
                    this.showRedeemCode = true;
                });
            },
            countNum(list){
                let count = 0;
                for (let index in list){
                   count = index;
                }
                return Number(count) + 1;
            },
            changeRedeemCode(code,id) {
                api.stopRedeem({code:code}).then(() =>{
                    this.$message.success('状态变更成功');
                })
            },
            clickCouponRedeemCodeRemove(id) {
                api.removeCoupon({id:id}).then(() =>{
                    this.$message.success('删除成功');
                    this.queryCouponList(1);
                })
            },
            querySearch(queryString, cb) {
                let restaurants = this.contractCoinTypes;
                let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                let suggest = [];
                for(let index in results) {
                    suggest.push({'value':results[index]});
                }
                cb(suggest);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.indexOf(queryString) === 0);
                };
            },
        }
    }
</script>

<style scoped>

</style>
